module.exports = require("@noble/curves/ed25519");